export const countries = [
  { label: "United Kingdom", value: 80 },
  { label: "United States of America", value: 236 },
];
